var _styled;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

// https://github.com/alphagov/govuk-frontend/tree/master/src/components/
import styled from 'react-emotion';
import React from 'react';
import PropTypes from 'prop-types';
import { ERROR_COLOUR } from 'govuk-colours';
import { MEDIA_QUERIES, SITE_WIDTH, SPACING } from '@govuk-react/constants';
import { withWhiteSpace } from '@govuk-react/hoc';
var StyledLabel = styled('label')((_styled = {
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
  width: '100%',
  ':after': {
    content: "''",
    display: 'table',
    clear: 'both'
  }
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  maxWidth: SITE_WIDTH
}, _styled), function (_ref) {
  var error = _ref.error;
  return {
    borderLeft: error ? "4px solid " + ERROR_COLOUR : undefined,
    marginRight: error ? SPACING.SCALE_3 : undefined,
    paddingLeft: error ? SPACING.SCALE_2 : undefined
  };
});

var Label = function Label(_ref2) {
  var className = _ref2.className,
      props = _objectWithoutProperties(_ref2, ["className"]);

  return React.createElement(StyledLabel, _extends({
    className: className
  }, props));
};

Label.defaultProps = {
  className: undefined
};
Label.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string
} : {};
export default withWhiteSpace({
  marginBottom: 0
})(Label);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/label/es/index.js
// module id = 10
// module chunks = 0